export default __webpack_public_path__ + "static/media/smartsearchnews.41c34822.jpg";